import constants from '@/libs/constant/constants'
import { requestListingAccess } from '@/libs/api/api'
import {message, loader} from '@/libs/helper'

export default{
    name: 'ClaimedMessage',
    props:{
        email: {
            type: String,
            default: () => ''
        },
        name: {
            type: String,
            default: () => ''
        },
        type: {
            type: String,
            default: () => ''
        },
        listing: {
            type: Object,
            default: () => {}
        },
        toggleClaimMessage: {
            type: Function,
            default: () => {}
        }
    },
    methods: {
        requestAccess(){
            loader(this, true);
            let body = {
                type: this.type,
                id: this.listing._id
            }
            requestListingAccess(body)
                .then((response)=>{
                    loader(this, false);
                    message(this, constants.messageType.SUCCESS, (response.message))
                }).catch((error)=>{
                    loader(this, false);
                    message(this, constants.messageType.ERROR, (error.message))
                })
        }
   }
}